"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconActionButton = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var globalVars_module_scss_1 = __importDefault(require("../../globalVars.module.scss"));
var StyledButton = styled_components_1.default.button(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tbackground-color: ", ";\n\tborder-radius: 3px 3px 3px 3px;\n\tborder: 1px solid ", ";\n\twidth: 20px;\n\theight: 20px;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\t.tws-i-icon {\n\t\tcolor: ", ";\n\t}\n\n\t&.tws-edit-handle,\n\t&.tws-delete-handle {\n\t\tcursor: pointer;\n\t\tmargin-left: 6px;\n\t}\n\n\t&.tws-edit-handle {\n\t\tfont-size: 12px;\n\t}\n\n\t&.tws-delete-handle {\n\t\tfont-size: 8px;\n\t}\n"], ["\n\tbackground-color: ", ";\n\tborder-radius: 3px 3px 3px 3px;\n\tborder: 1px solid ", ";\n\twidth: 20px;\n\theight: 20px;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\t.tws-i-icon {\n\t\tcolor: ", ";\n\t}\n\n\t&.tws-edit-handle,\n\t&.tws-delete-handle {\n\t\tcursor: pointer;\n\t\tmargin-left: 6px;\n\t}\n\n\t&.tws-edit-handle {\n\t\tfont-size: 12px;\n\t}\n\n\t&.tws-delete-handle {\n\t\tfont-size: 8px;\n\t}\n"])), globalVars_module_scss_1.default.tertiaryGray3, globalVars_module_scss_1.default.secondaryGray2, globalVars_module_scss_1.default.mainGray);
function IconActionButton(_a) {
    var label = _a.label, children = _a.children, rest = __rest(_a, ["label", "children"]);
    return (react_1.default.createElement(StyledButton, __assign({ className: 'action-button', title: label }, rest), children));
}
exports.IconActionButton = IconActionButton;
var templateObject_1;
